module.exports = __webpack_public_path__ + "img/BL.feadcac9.svg";